import { render, staticRenderFns } from "./AssignLicenseLearners.vue?vue&type=template&id=97dfaefa&scoped=true&"
import script from "./AssignLicenseLearners.vue?vue&type=script&lang=js&"
export * from "./AssignLicenseLearners.vue?vue&type=script&lang=js&"
import style0 from "./AssignLicenseLearners.vue?vue&type=style&index=0&id=97dfaefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dfaefa",
  null
  
)

export default component.exports